module.exports = __webpack_public_path__ + "623e9a2f13d75560494a0125eb32ed6f.png";